import { all } from 'redux-saga/effects'
import user from './user/sagas'
import menu from './menu/sagas'
import settings from './settings/sagas'
import member from './member/sagas'
import profile from './profile/sagas'
import device from './device/sagas'
import clinic from './clinic/sagas'
import notifications from './notifications/sagas'
import sockets from './socket/sagas'
import clinicPatient from './clinicPatient/sagas'
import liveRespiration from './liveRespiration/sagas'
import alertSubscription from './alertSubscription/sagas'
import billingEligibility from './billingEligibility/sagas'
import dashboard from './dashboard/sagas'
import report from './report/sagas'
import billing from './billing/sagas'
import medicalGroup from './medicalGroup/sagas'
// import trackingReport from './tracking/sagas'

export default function* rootSaga() {
  yield all([
    menu(),
    device(),
    user(),
    settings(),
    member(),
    profile(),
    clinic(),
    notifications(),
    sockets(),
    clinicPatient(),
    liveRespiration(),
    alertSubscription(),
    billingEligibility(),
    dashboard(),
    report(),
    billing(),
    medicalGroup(),
    // trackingReport(),
  ])
}
